<template>
  <div>
    <Head title="分類管理" />
    <ScrollTop />

    <Breadcrumb :home="breadcrumb_home" :model="breadcrumb_paths" />

    <Dialog :visible.sync="show_dialog" :modal="true">
      <template #header>
        <h3>{{ dialog_category.settings.title }}</h3>
      </template>

      <div class="flex flex-row justify-begin items-center gap-2 my-2">
        <label for="name">標籤名稱</label>
        <InputText
          id="name"
          type="text"
          v-model="dialog_category.name"
          autofocus
        />
      </div>
      <div class="error_information" v-if="dialog_category.errors.name">
        {{ dialog_category.errors.name }}
      </div>

      <div class="flex flex-row justify-begin items-center gap-2 my-2">
        <label for="name">網址簡稱</label>

        <InputText id="slug" type="text" v-model="dialog_category.slug" />
      </div>
      <div class="error_information" v-if="dialog_category.errors.slug">
        {{ dialog_category.errors.slug }}
      </div>

      <template #footer>
        <Button
          :label="dialog_category.settings.button"
          @click="upsertingCategory"
        />
      </template>
    </Dialog>

    <div class="w-full flex flex-row items-center justify-end gap-4">
      <Button v-if="!isEditing" label="新增" @click="showDialog('add')" />
      <Button
        v-if="!isEditing"
        label="順序及層次調整"
        class="p-button-outlined"
        @click="enterEditingMode"
      />
      <Button
        v-if="isEditing"
        label="取消"
        class="p-button-outlined"
        @click="restoreCategory"
      />
      <Button v-if="isEditing" label="儲存" @click="saveCategory" />
    </div>

    <div class="w-full pt-3">
      <DraggableNestedCategory :isEditing="isEditing" :category="categories" />
    </div>
  </div>
</template>

<script>
import Layout from "../Layout";
import ScrollTop from "primevue/scrolltop";
import Breadcrumb from "@/Shared/Components/Breadcrumb";
import Dialog from "primevue/dialog";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import DraggableNestedCategory from "./Components/DraggableNestedCategory";

export default {
  layout: Layout,
  components: {
    ScrollTop,
    Breadcrumb,
    Dialog,
    InputText,
    Button,
    DraggableNestedCategory,
  },
  data() {
    return {
      breadcrumb_home: {
        label: "商品分類管理",
        disabled: true,
      },
      breadcrumb_paths: [
        {
          label: "分類管理",
          disabled: true,
        },
      ],
      categories: this.$page.props.categories,
      isEditing: false,
      show_dialog: false,
      originalCategory: null,
      dialog_category: {
        id: null,
        name: null,
        slug: null,
        errors: {
          name: null,
          slug: null,
        },
        settings: {
          title: null,
          button: null,
          show: false,
        },
      },
    };
  },
  methods: {
    enterEditingMode() {
      this.originalCategory = JSON.parse(JSON.stringify(this.categories));
      this.isEditing = true;
    },
    restoreCategory() {
      this.categories = this.originalCategory;
      this.originalCategory = null;
      this.isEditing = false;
    },
    saveCategory() {
      this.originalCategory = null;
      this.isEditing = false;
      this.$inertia.post(route("admin.category.save"), this.categories, {
        only: ["categories"],
        onSuccess: (page) => {
          this.categories = page.props.categories;
        },
      });
    },
    showDialog(type, category = null) {
      switch (type) {
        case "add":
          this.dialog_category.settings = {
            title: "新增標籤",
            button: "新增",
          };

          this.dialog_category.id = null;
          this.dialog_category.name = null;
          this.dialog_category.slug = null;

          break;
        case "edit":
          this.dialog_category.settings = {
            title: "編輯標籤",
            button: "儲存",
          };

          this.dialog_category.id = category.id;
          this.dialog_category.name = category.name;
          this.dialog_category.slug = category.slug;

          break;
      }
      this.show_dialog = true;
    },
    upsertingCategory() {
      if (!this.dialog_category.name || !this.dialog_category.slug) {
        if (!this.dialog_category.name) {
          this.dialog_category.errors.name = "↑ 請輸入標籤名稱";
        } else {
          this.dialog_category.errors.name = null;
        }

        if (!this.dialog_category.slug) {
          this.dialog_category.errors.slug = "↑ 請輸入網址簡稱";
        } else {
          this.dialog_category.errors.slug = null;
        }
      } else {
        this.dialog_category.errors = {
          name: null,
          slug: null,
        };

        this.$inertia.post(
          route("admin.category.upsert"),
          {
            id: this.dialog_category.id,
            name: this.dialog_category.name,
            slug: this.dialog_category.slug,
          },
          {
            only: ["categories"],
            onSuccess: (page) => {
              this.show_dialog = false;
              this.dialog_category.name = null;
              this.dialog_category.slug = null;
              this.categories = page.props.categories;
            },
          }
        );
      }
    },
  },
  mounted() {
    this.$gon("category.refresh", function (page) {
      this.categories = page.props.categories;
    });

    this.$gon("category.edit", function (category) {
      this.showDialog("edit", category);
    });
  },
};
</script>

<style lang="postcss">
.p-breadcrumb {
  @apply border-0;
}

.error_information {
  @apply text-red pl-1;
}
</style>

<style>
/*  */
</style>